import Checkbox from '@creditflowresearch/uilib/Checkbox';
import CheckboxWithTooltip from '@/creditflowresearch/ui/common/components/Sidebar/CheckboxWithTooltip';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import useCreditProductsSection
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/CreditProducts/useCreditProductsSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import {
  FilterSectionIds,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';

const CreditProducts = () => {
  const {
    items,
    selectedValues,
    isAllSelected,
    isIndeterminate,
    onChange,
    onSelectAll,
  } = useCreditProductsSection(FilterSectionIds.CreditProducts);

  return (
    <FilterSection
      sectionId={ FilterSectionIds.CreditProducts }
      header={ (
        <FilterSectionHeader
          title="CREDIT PRODUCTS"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ onSelectAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest='productsFiltersAllCheckbox'
            />
          ) }
        />
      ) }
    >
      { items.map((item) => (
        <FilterItem key={ item.value } isExpandable={ false }>
          <CheckboxWithTooltip
            label={ item.name }
            checked={ selectedValues.includes(item.value) }
            onChange={ () => onChange(item.value) }
            disabled={ item.disabled }
            dataTest={ `checkbox-${ item.value }` }
          />
        </FilterItem>
      )) }
    </FilterSection>
  );
};

export default CreditProducts;
